/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetOrderingMenuAssignmentsRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetOrderingMenuAssignmentsResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setOrderingMenuAssignments = (request: SetOrderingMenuAssignmentsRequest, options?: CashRequestOptions) => post<SetOrderingMenuAssignmentsRequest, SetOrderingMenuAssignmentsResponse>("/2.0/cash/set-ordering-menu-assignments", request, {...options, rejectOnError: true })